export enum CharterFilter {
  All = 'ALL',
  Request = 'WAITING_FOR_APPROVAL',
  PendingPayment = 'WAITING_FOR_PAYMENT',
  Confirmed = 'BOOKED',
  Canceled = 'CANCELED',
  History = 'HISTORY',
  Enquiries = 'ENQUIRIES'
}
